import { useState } from "react";
import { ArrowLeft, Phone, ShieldCheck, Trash2 } from "lucide-react";
import { forgetThisPhone } from "./api";
import { openMenu } from "./App";
import { t, useLang } from "./i18n";

/** What the app keeps about a customer, in plain words, and a way to wipe what is saved on the phone. */
export function Privacy({ phone, onForget }: { phone: string; onForget: () => void }) {
  useLang();
  const [done, setDone] = useState(false);
  return <div className="mx-auto max-w-lg px-4 pt-[max(1rem,env(safe-area-inset-top))] pb-10">
    <button onClick={openMenu} className="mb-4 flex h-11 items-center gap-2 rounded-full pr-4 text-mute"><ArrowLeft size={20}/>{t("menu")}</button>
    <section className="card space-y-4 p-6">
      <h1 className="flex items-center gap-2 text-2xl"><ShieldCheck className="text-mango" size={26}/>{t("privacyTitle")}</h1>
      {(["privacyWhat", "privacyWhy", "privacyWhere", "privacyPhone", "privacyDelete"] as const).map((key) => <p key={key} className="leading-relaxed text-mute">{t(key)}</p>)}
      {phone && <a href={`tel:${phone.replace(/[^\d+]/g, "")}`} className="btn-quiet w-full"><Phone size={18}/>{t("call")}</a>}
      <button className="btn-quiet w-full border-bad/40 text-bad" disabled={done} onClick={() => { forgetThisPhone(); onForget(); setDone(true); }}><Trash2 size={18}/>{done ? t("forgotten") : t("forgetMe")}</button>
    </section>
  </div>;
}
